// Description: Form to handle the creation and updating of SMS templates.
// Updated: 20/08/2025 

// React Components
import React, { useEffect, useState } from 'react';

// Material UI Components
import { Grid, FormControl, Button, Tooltip } from '@mui/material';

// Components and Functions for the project
import TemplateInput from '../../components/Input/TemplateInput';
import DynamicButton from '../../components/DynamicButton/DynamicButton';
import { notify } from '../../utils/utils';
import TestTemplateModal from '../../components/Modals/TestTemplateModal';
import themeColors from '../../components/ThemeColors/ThemeColors.js';
import { TestMessage } from '../../api/aws/Templates/TestMessage';


// render the form of SMS
const FormSMS = ({ messageTemporary, setMessageTemporary, variablesOfTemplate, setViewWhatsAppScreenProps, saveTemplate, edit = false, setOpenTestModal, disabledTestModal }) => {

    const [imageBase64, setImageBase64] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (imageBase64) {
            setViewWhatsAppScreenProps((prevProps) => {
                const newMessage = {
                    id: prevProps.messages.messages.length + 1,
                    type: 'img',
                    message: `${imageBase64}`,
                    fromMe: true
                };

                return {
                    ...prevProps,
                    messages: {
                        ...prevProps.messages,
                        messages: [...prevProps.messages.messages, newMessage]
                    }
                };
            });
        }
    }, [imageBase64, setViewWhatsAppScreenProps]);

    const onSubmit = async () => {
        if (messageTemporary.length) {
            setLoading(true);

            try {
                await saveTemplate();
            } catch (error) {
                console.error('Erro ao buscar dados da API:', error);
                throw new Error('Erro ao buscar dados da API');
            } finally {
                setLoading(false);
            }

        } else {
            notify("Error", "Escreva uma mensagem antes de salvar o modelo", true);
        }
    }

    return (
        <>
            <Grid container spacing={2} style={{ marginTop: '20px' }}>
                <TemplateInput handleChange={setMessageTemporary} type={'sms'} value={messageTemporary} variablesOfTemplate={variablesOfTemplate} />

                <Grid item xs={6}>
                    <FormControl fullWidth sx={{ justifyContent: 'flex-end' }}>
                        {disabledTestModal ? (
                            <Tooltip arrow title="Após a edição do modelo, é necessário salvá-lo e aguardar a análise antes de enviá-lo ou testá-lo.">
                                <span>
                                    <Button
                                        disabled
                                        onClick={() => setOpenTestModal(true)}
                                        sx={{
                                            width: '100%',
                                            padding: '13px',
                                            background: themeColors.purple300,
                                            '&:hover': { background: themeColors.purple400 },
                                            color: themeColors.purple700,
                                        }}
                                        variant="contained"
                                    >
                                        Testar Envio
                                    </Button>
                                </span>
                            </Tooltip>
                        ) : (
                            <Button
                                onClick={() => setOpenTestModal(true)}
                                sx={{
                                    width: '100%',
                                    padding: '13px',
                                    background: themeColors.purple300,
                                    '&:hover': { background: themeColors.purple400 },
                                    color: themeColors.purple700,
                                }}
                                variant="contained"
                            >
                                Testar Envio
                            </Button>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <Button onClick={onSubmit} disabled={loading} style={{ width: '100%', padding: '13px' }} variant={"contained"} children={edit ? "Editar Modelo" : "Salvar Modelo"} />
                    </FormControl>
                </Grid>
            </Grid >
        </>
    );
};

export default FormSMS;